import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Tooltip from '@mui/material/Tooltip';

const BRANDS = [
  { key: '_aeb',   label: 'A' },
  { key: '_landi', label: 'L' },
  { key: '_lovato', label: 'L' },
];

function BrandLetter({ label, green, tooltip }) {
  return (
    <Tooltip title={tooltip}>
      <span style={{
        display: 'inline-block',
        width: 14,
        textAlign: 'center',
        fontWeight: green ? 'normal' : 'bold',
        fontSize: 13,
        color: green ? '#2e7d32' : '#c62828',
        cursor: 'default',
        userSelect: 'none',
      }}>
        {label}
      </span>
    </Tooltip>
  );
}

/** Column: doc_brands — green if brand has ≥1 doc (null docs count for every brand) */
function DocBrandsFormatter({ row }) {
  const counters = row.counters;
  if (!counters || !counters.doc) {
    return <span style={{ color: '#bbb', fontSize: 12 }}>–</span>;
  }
  const nullVal = counters.doc['null'] || 0;
  return (
    <div style={{ display: 'flex', gap: 0, alignItems: 'center' }}>
      {BRANDS.map(b => {
        const val = (counters.doc[b.key] || 0) + nullVal;
        const green = val >= 1;
        const brandName = b.key.replace('_', '').toUpperCase();
        const tooltip = `${brandName}: ${counters.doc[b.key] || 0} doc${nullVal > 0 ? ` (+${nullVal} shared)` : ''}`;
        return <BrandLetter key={b.key} label={b.label} green={green} tooltip={tooltip} />;
      })}
    </div>
  );
}

/** Column: pkg_cal_brands — green if brand has ≥1 pkg AND ≥1 cal (null counts for every brand) */
function PkgCalBrandsFormatter({ row }) {
  const counters = row.counters;
  if (!counters || !counters.pkg || !counters.cal) {
    return <span style={{ color: '#bbb', fontSize: 12 }}>–</span>;
  }
  const nullPkg = counters.pkg['null'] || 0;
  const nullCal = counters.cal['null'] || 0;
  return (
    <div style={{ display: 'flex', gap: 0, alignItems: 'center' }}>
      {BRANDS.map(b => {
        const pkgVal = (counters.pkg[b.key] || 0) + nullPkg;
        const calVal = (counters.cal[b.key] || 0) + nullCal;
        const green = pkgVal >= 1 && calVal >= 1;
        const brandName = b.key.replace('_', '').toUpperCase();
        const tooltip = `${brandName}: ${counters.pkg[b.key] || 0} pkg (+${nullPkg} shared), ${counters.cal[b.key] || 0} cal (+${nullCal} shared)`;
        return <BrandLetter key={b.key} label={b.label} green={green} tooltip={tooltip} />;
      })}
    </div>
  );
}

export function DocBrandsTypeProvider({ for: forColumns }) {
  return (
    <DataTypeProvider
      formatterComponent={({ row }) => <DocBrandsFormatter row={row} />}
      for={forColumns}
    />
  );
}

export function PkgCalBrandsTypeProvider({ for: forColumns }) {
  return (
    <DataTypeProvider
      formatterComponent={({ row }) => <PkgCalBrandsFormatter row={row} />}
      for={forColumns}
    />
  );
}
